import React from 'react';
import ErrorPage from './ErrorPage';
import MainCardContainer from './../MainCardContainer';
import { useLanguage } from '../../context/LanguageContext';

const Error500 = () => {
  const { labels } = useLanguage();
  const errorPages = labels.errorPages || {};
  return (
    <MainCardContainer
      headTitle=""
      content={[
        <ErrorPage
          title={errorPages.error500?.TITLE}
          subtitle={errorPages.error500?.SUBTITLE}
          icon={errorPages.error500?.ICON}
          key={0}
        />
      ]}
    />
  );
};

export default Error500;
